import { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const useServiceAnimations = (isLoaded) => {
    const params = new URLSearchParams(window.location.search); // id=123
    const token = localStorage.getItem('redirect');

    useEffect(() => {
        const initAnimations = () => {
            const sections = gsap.utils.toArray('.slide:not(.banner)');
            const banner = document.querySelector('.banner');
            const footer = document.querySelector('footer');

            // Reset scroll to banner
            if (banner) {
                gsap.to(window, { scrollTo: banner, duration: 0, immediateRender: true });
            }

            sections.forEach((section, i) => {
                ScrollTrigger.create({
                    trigger: section,
                    start: 'top 10%',
                    end: () => `+=${window.innerHeight}`,
                    pin: true,
                    pinSpacing: false,
                    onEnter: () => {
                        if (i === sections.length - 1) {
                            gsap.to(footer, { display: 'block', duration: 0.5 });
                        }
                    },
                    onLeaveBack: () => {
                        if (i === sections.length - 1) {
                            gsap.to(footer, { display: 'block', duration: 0.5 });
                        }
                    },
                });

                if (i > 0) {
                    gsap.to(sections[i - 1], {
                        scrollTrigger: {
                            trigger: section,
                            start: 'top 75%',
                            end: 'top top',
                            scrub: true,
                        },
                        opacity: 0,
                        filter: 'blur(10px)',
                    });
                }
            });
        };

        const destroyAnimations = () => {
            ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
        };

        const handleResize = () => {
            if (window.innerWidth >= 800 && isLoaded) {
                destroyAnimations();
                initAnimations();
                ScrollTrigger.refresh();
            } else {
                destroyAnimations();
            }
        };

        // Initialize animations if width >= 800px and content is loaded
        if (window.innerWidth >= 800 && isLoaded) {
            initAnimations();
        }

        window.addEventListener('resize', handleResize);

        // Handle smooth scrolling to redirect target or banner
        if (isLoaded) {
            const target = token ? `#${token}` : '.banner';
            console.log("target",target);
            console.log("Aminationtarget",target);
            gsap.to(window, {
                duration: 1.5, // Smooth scroll duration
                scrollTo: { y: target, offsetY: 80 }, // Offset to avoid header overlap
                ease: 'power2.out', // Smooth ease-out animation
            });

            // Clean up localStorage if redirect was used
            if (token) {
                localStorage.removeItem('redirect');
            }
        }

        return () => {
            destroyAnimations();
            window.removeEventListener('resize', handleResize);
        };
    }, [isLoaded, token]); // Trigger animations only when isLoaded is true and token changes
};

export default useServiceAnimations;
